import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "gf_access_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401) {
      // expired/invalid — clear token
      const path = typeof window !== "undefined" ? window.location.pathname : "";
      if (path.startsWith("/dashboard") || path.startsWith("/admin")) {
        setToken(null);
      }
    }
    return Promise.reject(e);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export function formatPrice(value, lang = "pt") {
  if (value == null) return "";
  if (lang === "pt") {
    return `R$ ${Number(value).toFixed(2).replace(".", ",")}`;
  }
  return `$${Number(value).toFixed(2)}`;
}

export function discountedPrice(p) {
  return p.price * (1 - (p.discount_percent || 0) / 100);
}
